import { TableColumnMeta } from "ds/components/Table/types";

export const SHARED_MODULES_TABLE_STORAGE_KEY = "shared-modules-table";
export const FILTERS_ORDER_SETTINGS_KEY = "sharedModulesFiltersOrder";

export enum SHARED_MODULES_COLUMN_ID {
  NAME = "NAME",
  VERSION = "VERSION",
  DESCRIPTION = "DESCRIPTION",
  SHARED_FROM = "SHARED_FROM",
  DROPDOWN = "DROPDOWN",
}

const MAX_CELL_WIDTH = 2000;

export const SHARED_MODULES_TABLE_COLUMNS_CONFIG: Record<
  SHARED_MODULES_COLUMN_ID,
  TableColumnMeta
> = {
  [SHARED_MODULES_COLUMN_ID.VERSION]: {
    id: SHARED_MODULES_COLUMN_ID.VERSION,
    title: "Version",
    minWidth: 112,
    defaultWidth: 114,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [SHARED_MODULES_COLUMN_ID.NAME]: {
    id: SHARED_MODULES_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 120,
    defaultWidth: 240,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [SHARED_MODULES_COLUMN_ID.DESCRIPTION]: {
    id: SHARED_MODULES_COLUMN_ID.DESCRIPTION,
    title: "Description",
    minWidth: 130,
    defaultWidth: 240,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: false,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [SHARED_MODULES_COLUMN_ID.SHARED_FROM]: {
    id: SHARED_MODULES_COLUMN_ID.SHARED_FROM,
    title: "Shared from",
    minWidth: 120,
    defaultWidth: 240,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [SHARED_MODULES_COLUMN_ID.DROPDOWN]: {
    id: SHARED_MODULES_COLUMN_ID.DROPDOWN,
    title: "Shared modules actions",
    noHeader: true,
    maxWidth: 60,
    minWidth: 60,
    defaultWidth: 60,
    allowsSorting: false,
    resizable: false,
    canHide: false,
    configurable: false,
    canPin: false,
    canMove: false,
  },
};

export const SORT_CONFIG: Record<SHARED_MODULES_COLUMN_ID, string> = {
  [SHARED_MODULES_COLUMN_ID.NAME]: "name",
  [SHARED_MODULES_COLUMN_ID.VERSION]: "version",
  [SHARED_MODULES_COLUMN_ID.DESCRIPTION]: "description",
  [SHARED_MODULES_COLUMN_ID.SHARED_FROM]: "sharedFrom",
  [SHARED_MODULES_COLUMN_ID.DROPDOWN]: "dropdown",
};
